import React from 'react';

const FileImportModal = () => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-sm text-center">
                <div className="flex justify-center mb-4">
                    <div className="h-10 w-10 border-4 border-complementaryPrimaryColor border-t-transparent rounded-full animate-spin"></div>
                </div>
                <h2 className="text-lg font-semibold text-gray-800 mb-2">Importing File...</h2>
                <p className="text-gray-600 text-sm">Please wait while we process your file.</p>
            </div>
        </div>
    );
};

export default FileImportModal;
